import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputAdornment,
  TextField,
} from "@mui/material";
import { ChangeEvent, useCallback, useEffect, useState } from "react";

import NoteAddIcon from "@mui/icons-material/NoteAddOutlined";
import { createStyleSheet } from "../utils/styles";
import { useTranslation } from "react-i18next";

const DeleteTaskDialog = (props: {
  open: boolean;
  onClose: () => void;
  onDelete: (deleteData: { notes: string }) => void;
}) => {
  const { open, onClose, onDelete } = props;
  const { t } = useTranslation("DeleteTaskDialog");

  // Component state
  const [deletionNotes, setDeletionNotes] = useState("");

  // Callbacks
  const handleDeletionNotesChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setDeletionNotes(event.target.value);
    },
    []
  );
  const handleDeleteTaskDialogAction = useCallback(() => {
    onDelete({ notes: deletionNotes });
  }, [onDelete, deletionNotes]);

  // Reactive code
  useEffect(() => {
    if (!open) {
      setDeletionNotes("");
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t("title")}</DialogTitle>
      <DialogContent>
        <FormControl sx={{ width: "100%" }}>
          <TextField
            label={t("deletionNotes")}
            variant="outlined"
            onChange={handleDeletionNotesChange}
            value={deletionNotes}
            fullWidth
            multiline
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <NoteAddIcon />
                  </InputAdornment>
                ),
              },
            }}
          />
        </FormControl>
        <DialogContentText sx={styles.dialogBody}>{t("body")}</DialogContentText>
      </DialogContent>
      <DialogActions sx={styles.dialogButtonContainer}>
        <Button onClick={onClose}>{t("common:cancel")}</Button>
        <Button autoFocus onClick={handleDeleteTaskDialogAction}>
          {t("common:deleteTaskAction")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const styles = createStyleSheet({
  dialogButtonContainer: {
    px: 3,
    marginBottom: 1,
  },
  dialogBody: {
    marginTop: 2,
  },
});

export default DeleteTaskDialog;
